// import Icon from '@ant-design/icons';
import React, { useState, useEffect } from "react";
import { Spin, message } from "antd";
import { LoadingOutlined, HomeOutlined } from "@ant-design/icons";
import { Tabs, Radio, Row, Col } from "antd";
import ZenVerBarChart from "./Common/Graph/ZenVerBarChart";
import ZenClusterColumnVer from "./Common/Graph/ZenClusterColumnVer";
import ZenHorBarChart from "./Common/Graph/ZenHorBarChart";
import ZenWaterfallChart from "./Common/Graph/ZenWaterfallChart";
import ZenPareto from "./Common/Graph/ZenPareto";
import ZenVerStackBar from "./Common/Graph/ZenVerStackBar";
import ZenGanttChart from "./Common/Graph/ZenGanttChart";
import ZenStackedNePo from "./Common/Graph/ZenStackedNePo";

import ZenDonut from "./Common/Graph/ZenDonut";

import ZenGauge from "./Common/Graph/ZenGauge";

import Angela from "./Common/DataCard/Angela";
import liracrypt from "../Liracrypt/liracrypt";
import SessionError from "../ApiErrorComp/SessionError";
import ApiErrorComp from "../ApiErrorComp/ApiErrorComp";
import digitalFactoryLogo from "../../images/DigitalFactory.png";
import { Link } from "react-router-dom";
import { getUrlCode } from "../../utils/CustomFunc";
// import RadialGradient from 'react-native-radial-gradient';

const antIcon = <LoadingOutlined style={{ fontSize: 80 }} spin />;

const boxShadow = "5px 5px 14px #181818,-5px -5px 14px #343434";

class ChartTemplate extends React.Component {
  state = {
    mainData: null,
    ZenGanttChart: null,
    ZenDonut: null,
    ZenVerBarChart: null,
    ZenHorBarChart: null,
    ZenPareto: null,

    loading: true,
    loginError: false,
    selectedTab: null,
    lid: "all",
    tabsData: null,
    selectedMnt: "all",
    table: null,
    dataLoading: false,
  };

  constructor(props) {
    super(props);
    this._isMounted = false;
  }

  onChange = (e) => {
    console.log("change--***");
    const st = this;
    this.setState({
      ...this.state,
      selectedTab: e.target.value,
      loading: true,
    });
    this.fetchTrendData(e.target.value);
  };

  changeLid = (lid) => {
    let val =
      this.state.lid === "all" ? lid : this.state.lid === lid ? "all" : lid;
    this.setState({ ...this.state, lid: val, dataLoading: true });
    this.fetchTrendData(this.state.selectedTab, val, this.state.selectedMnt);
  };

  getTabs() {
    liracrypt
      .get("/corp/corpdashdynamicparam", {})
      .then((response) => {
        let __tabs = response.data.data;
        this.setState(
          {
            tabsData: __tabs,
            selectedTab: __tabs?.find((x) => x.isDefault === true)?.subTyp,
          },
          () => {
            if (this._isMounted && this.state.selectedTab) {
              this.fetchTrendData(this.state.selectedTab);
            }
          }
        );
      })
      .catch((err) => {
        console.log(err);
      });
  }

  componentDidMount() {
    this.props.setPageHeader("Dashboard");
    this._isMounted = true;
    this.getTabs();
  }

  componentWillUnmount() {
    this._isMounted = false;
    this.loginError = false;
  }

  fetchTrendData = (selectedTab, lid = "all", mnt = "all") => {
    liracrypt
      .get("/textapi", {
        lid,
        mnt,
        typ: "MainGraph",
        subTyp: selectedTab,
        dn: "TemplateDualChartZen",
      })
      .then(({ data }) => {
        const resp = { ...data };
        let respData = {};
        respData["ZenGanttChart"] = resp["data"]["ZenGanttChart"];
        respData["ZenDonut"] = resp["data"]["ZenDonut"];
        respData["ZenVerBarChart"] = resp["data"]["ZenVerBarChart"];
        respData["ZenHorBarChart"] = resp["data"]["ZenHorBarChart"];
        respData["ZenPareto"] = resp["data"]["ZenPareto"];
        respData["mainData"] = { ...resp };
        this._isMounted &&
          this.setState(
            {
              ...this.state,
              ...respData,
              loading: false,
              dataLoading: false,
            },
            () => {
              // console.log(this.state.dailyTrend);
            }
          );
      })
      .catch((error) => {
        // message.error('ERROR: Unable to save!', 4);
        console.log(error);
        if (error.response !== undefined) {
          if (error.response.status !== 401) {
            ApiErrorComp(error.response.status);
          } else {
            this.setState({
              ...this.state,
              loginError: true,
            });
          }
        }
      });
  };

  changeBasicGraph(data) {
    let val =
      this.state.selectedMnt === "all"
        ? data._id
        : this.state.selectedMnt === data._id
        ? "all"
        : data._id;
    this.setState({
      selectedMnt: val,
      dataLoading: true,
    });
    this.fetchTrendData(this.state.selectedTab, this.state.lid, val);
  }

  render() {
    if (this.state.mainData) {
      return (
        <>
          <SessionError visible={this.state.loginError} />
          <div
            style={{
              background: "#000000",
              paddingTop: 10,
              //   backgroundImage:
              //     "radial-gradient(circle, rgba(98,46,43,1) 0%, rgba(43,36,46,1) 50%, rgba(26,29,36,1) 100%)",
            }}
          >
            <div
              style={{
                display: "inline-flex",
                alignContent: "center",
                alignItems: "center",
                justifyContent: "space-around",
                width: "100%",
              }}
            >
              <div
                className="logo"
                style={{
                  margingLeft: 14,
                  padding: 10,
                }}
              >
                <img src={digitalFactoryLogo} alt="sarex" width="80" />
              </div>
              <Radio.Group
                className="managerTabs"
                value={"small"}
                onChange={this.onChange}
              >
                {this.state.tabsData &&
                  this.state.tabsData.map((tab, index) => (
                    <Radio.Button
                      key={index}
                      className={tab?.label?.toLowerCase()}
                      style={{
                        background: "#191C24",
                        border: "1px solid #3c3e4f",
                        color: tab?.color,
                        textAlign: "center",
                        fontSize: "17px",
                        fontWeight: 600,
                        boxShadow: boxShadow,
                        maxWidth: "200px",
                      }}
                      value={tab?.subTyp}
                    >
                      {tab?.label}
                    </Radio.Button>
                  ))}
              </Radio.Group>
              <div
                style={{
                  //   boxShadow:
                  //     "rgb(30 30 30) 5px 5px 10px, rgb(46 46 46) -5px -5px 10px",
                  borderRadius: 10,
                  padding: 10,
                  marginRight: 25,
                  marginBottom: 13,

                  background: "#191C24",
                  //   backgroundImage:
                  //     "linear-gradient(145deg, rgba(106,106,111,1) 0%, rgba(42,42,52,0.8748541652989321) 57%, rgba(33,32,40,1) 100%)",
                  border: "1px solid #3c3e4f",
                }}
              >
                <Link to={`/v02/${getUrlCode()}/dashboard`}>
                  <HomeOutlined
                    style={{
                      fontSize: 25,
                    }}
                  />
                </Link>
              </div>
            </div>
            {this.state.loading === false ? (

              
              <Row style={{ background: "#000000" }}>
                <div
                  style={{
                    borderRadius: "10px",
                    background: "#191C24",
                    border: "1px solid #3c3e4f",
                    margin: "10px 0px 0px 10px",
                    height: "450px",
                    width: "900px",
                  }}
                >
                  <ZenGanttChart
                    divId={"ZenGanttChart1"}
                    data={this.state.ZenGanttChart.data}
                    config={this.state.ZenGanttChart.config}
                    onChange={(data) => this.changeBasicGraph(data)}
                  />
                </div>

                <div
                  style={{
                    borderRadius: "10px",
                    background: "#191C24",
                    border: "1px solid #3c3e4f",
                    margin: "10px 0px 0px 10px",

                    width: "600px",
                  }}
                >
                  <ZenDonut
                    divId={"ZenDonut01"}
                    data={this.state.ZenDonut.data}
                    config={this.state.ZenDonut.config}
                    onChange={(data) => this.changeBasicGraph(data)}
                  />
                </div>


                <div
                  style={{
                    borderRadius: "10px",
                    background: "#191C24",
                    border: "1px solid #3c3e4f",
                    margin: "10px 0px 0px 10px",
                    height: "450px",
                    width: "500px",
                  }}
                >
                  <ZenVerBarChart
                    divId={"ZenVerBarChart1"}
                    data={this.state.ZenVerBarChart.data}
                    config={this.state.ZenVerBarChart.config}
                    onChange={(data) => this.changeBasicGraph(data)}
                  />
                </div>

                <div
                  style={{
                    borderRadius: "10px",
                    background: "#191C24",
                    border: "1px solid #3c3e4f",
                    margin: "10px 0px 0px 10px",

                    width: "500px",
                  }}
                >
                  <ZenHorBarChart
                    divId={"ZenHorBarChart1"}
                    data={this.state.ZenHorBarChart.data}
                    config={this.state.ZenHorBarChart.config}
                    onChange={(data) => this.changeBasicGraph(data)}
                  />
                </div>

                <div
              style={{
                borderRadius: "10px",
                background: "#191C24",
                border: "1px solid #3c3e4f",
                margin: "10px 0px 0px 10px",

                width: "400px",
              }}
            >
              <ZenPareto
                divId={"ZenPareto01"}
                data={this.state.ZenPareto.data}
                config={this.state.ZenPareto.config}
                onChange={(data) => this.changeBasicGraph(data)}
              />
            </div>














              </Row>



            ) : (
              <div className="Loading" style={{ minHeight: "100vh" }}>
                <Spin indicator={antIcon} />
              </div>
            )}
          </div>
        </>
      );
    } else {
      return (
        <>
          {" "}
          <SessionError visible={this.state.loginError} />
          <div className="contentEmpty"></div>
        </>
      );
    }
  }
}

export default ChartTemplate;